import { t } from "@/i18n-js/instance";
import { useModal } from "@circle-react/components/Layout/ModalManagerProvider";
import { Modal } from "@circle-react-uikit/ModalV2";
import { ModalBody } from "./ModalBody";
import { ModalHeader } from "./ModalHeader";

interface AiActionsModalComponentProps {
  afterClose?: () => void;
  source?: string;
}

export const AiActionsModalComponent = ({
  afterClose,
}: AiActionsModalComponentProps) => {
  const modal = useModal();

  const handleClose = async () => {
    await modal.hide();
    modal.remove();
    afterClose?.();
  };

  return (
    <Modal
      title={t("settings.ai_actions.modal.title")}
      isOpen={modal.visible}
      onClose={handleClose}
    >
      <Modal.Overlay />
      <Modal.Content size="2xl">
        <ModalHeader handleClose={handleClose} />
        <ModalBody handleClose={handleClose} />
      </Modal.Content>
    </Modal>
  );
};
